/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-25 22:33:39
 * @LastEditTime: 2022-01-26 18:30:50
 * @LastEditors: zhao - 🍉
 * @Description: 
 * @FilePath: /zhzj-admin/src/services/ZJBSyncDataRecord.js
 */

import request from "../utils/request";


/**
 * 获取租金宝统计报表
 * @param {{ current: 0,pageSize: 0,syncDate: string }} data 
 * @returns 
 */
export function fetchZJBSyncDataRecord (data) {
    return request({
        url: '/platform/zjbDataSyncReport/findDataSyncReportPage',
        method: 'post',
        data
    })
}

/**
 * 
 * 获取租金宝统计报表 - 楼栋详情
 * @export
 * @param {{current:0,operationType:0,pageSize:0,syncEndDate:string,syncStartDate:string}} data
 * @returns
 */
export function fetchZJBSyncDataBuildingInfo (data) {
    return request({
        url: '/platform/zjbDataSyncReport/findDataSyncReportBuildingInfo',
        method: 'post',
        data
    })
}

/**
 * 
 * 获取租金宝统计报表 - 合同详情
 * @export
 * @param {{current:0,operationType:0,pageSize:0,syncEndDate:string,syncStartDate:string}} data
 * @returns
 */
export function fetchZJBSyncDataRentContractInfo (data) {
    return request({
        url: '/platform/zjbDataSyncReport/findDataSyncReportRentContractInfo',
        method: 'post',
        data
    })
}

/**
 * 
 * 获取租金宝统计报表 - 房源详情
 * @export
 * @param {{current:0,operationType:0,pageSize:0,syncEndDate:string,syncStartDate:string}} data
 * @returns
 */
export function fetchZJBSyncDataHouseInfo (data) {
    return request({
        url: '/platform/zjbDataSyncReport/findDataSyncReportHouseInfo',
        method: 'post',
        data
    })
}

/**
 * 
 * 获取租金宝统计报表 - 项目详情
 * @export
 * @param {{current:0,operationType:0,pageSize:0,syncEndDate:string,syncStartDate:string}} data
 * @returns
 */
export function fetchZJBSyncDataProjectInfo (data) {
    return request({
        url: '/platform/zjbDataSyncReport/findDataSyncReportProjectInfo',
        method: 'post',
        data
    })
}


/**
 * 
 * 获取租金宝统计报表 - 商户详情
 * @export
 * @param {{current:0,operationType:0,pageSize:0,syncEndDate:string,syncStartDate:string}} data
 * @returns
 */
export function fetchZJBSyncDataMerchantInfo (data) {
    return request({
        url: '/platform/zjbDataSyncReport/findDataSyncReportMerchantInfo',
        method: 'post',
        data
    })
}

/**
 * 
 * 获取租金宝统计报表 - 订单详情
 * @export
 * @param {{current:0,operationType:0,pageSize:0,syncEndDate:string,syncStartDate:string}} data
 * @returns
 */
export function fetchZJBSyncDataPayorderInfo (data) {
    return request({
        url: '/platform/zjbDataSyncReport/findDataSyncReportPayOrderInfo',
        method: 'post',
        data
    })
}
/**
 *
 * 惠市宝分账规则支付- 订单详情
 * @export
 * @param {{current:0,operationType:0,pageSize:0,syncEndDate:string,syncStartDate:string}} data
 * @returns
 */
export function  fetchHsbPayClrgRulePayorderInfo(data) {
    return request({
        url: '/platform/traderecord/findPage',
        method: 'post',
        data
    })
}




// WEBPACK FOOTER //
// ./src/services/ZJBSyncDataRecord.js